import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledGridStack = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: "10px",
  "@media print": {
    gap: "5px",
  },
});

export const StyledBarTooltip = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.hubColors.white,
  borderRadius: "8px",
  padding: "12px 14px",
  minWidth: 180,
  maxWidth: 240,
  boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
  border: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  svg: {
    color: theme.palette.hubColors.greyDark,
  },
}));

export const StyledTitleStack = styled(Stack)(({ theme }) => ({
  height: "40px",
  flexDirection: "row",
  gap: "25px",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: theme.palette.hubColors.white,
  borderBottom: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  "& .MuiOutlinedInput-root": {
    // width: 125,
    padding: "5px 10px",
    borderRadius: 6,
    svg: {
      width: 12,
      height: 12,
    },
  },
}));

export const StyledTitledSubStack = styled(Stack, {
  shouldForwardProp: (prop) => !["disableYPadding"].includes(prop),
})(({ disableYPadding }) => ({
  flexDirection: "row",
  gap: "10px",
  alignItems: "center",
  padding: disableYPadding ? "0px 15px" : "7px 15px",
  height: "100%",
}));